import { render } from "./SimpleLoader.vue?vue&type=template&id=3c71e206&scoped=true"
import script from "./SimpleLoader.vue?vue&type=script&lang=js"
export * from "./SimpleLoader.vue?vue&type=script&lang=js"

import "./SimpleLoader.vue?vue&type=style&index=0&id=3c71e206&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c71e206"]])

export default __exports__